{
  "readmission": {
    "personalDetails": {
      "givenName": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "photograph": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "surname": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "maidenName": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "nationalityCountryCode": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "languageSpoken": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "sex": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "civilStatus": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirth": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "dateOfBirth": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "physicalDescription": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "alias": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "lastAddress": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "submittingAgencyReference": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "indicationOfDangerousPerson": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "stateOfHealth": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "observations": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirthRegionCity": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "familyInformation": {
      "givenName": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "surname": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "maidenName": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "nationalityCountryCode": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "languageSpoken": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "sex": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "relationship": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "placeOfBirth": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "dateOfBirth": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "alias": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "physicalDescription": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirthRegionCity": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "relatedRecords": {
      "reference": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "referenceType": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "meansOfEvidence": {
      "meansOfEvidenceDocumentType": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "documentNo": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "dateOfIssuance": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "document": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "expirationDate": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfIssuance": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "issuingAuthority": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "transferModalities": {
      "typeOfTransfer": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "proposedReturnDate": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "proposedReturnTime": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "transferDocumentType": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "transferDocumentNo": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "returneeIssuingAuthority": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "returneePlaceOfIssuance": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "returneeExpirationDate": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortPossible": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "escortFullName": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortNationalityCountryCode": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortPassportNo": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortIssuanceDate": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortExpirationDate": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortIssuingAuthority": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortPlaceOfIssuance": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    }
  },
  "return": {
    "personalDetails": {
      "givenName": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "photograph": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "surname": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "maidenName": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "nationalityCountryCode": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "languageSpoken": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "sex": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "civilStatus": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirth": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "dateOfBirth": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "physicalDescription": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "alias": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "lastAddress": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "submittingAgencyReference": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "indicationOfDangerousPerson": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "stateOfHealth": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "observations": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirthRegionCity": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "familyInformation": {
      "givenName": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "surname": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "maidenName": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "nationalityCountryCode": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "languageSpoken": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "sex": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "relationship": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirth": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "dateOfBirth": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "alias": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "physicalDescription": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirthRegionCity": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "relatedRecords": {
      "reference": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "referenceType": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "meansOfEvidence": {
      "meansOfEvidenceDocumentType": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "documentNo": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "dateOfIssuance": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "document": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "expirationDate": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfIssuance": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "issuingAuthority": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "transferModalities": {
      "typeOfTransfer": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "proposedReturnDate": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "proposedReturnTime": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "transferDocumentType": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "transferDocumentNo": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "returneeIssuingAuthority": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "returneePlaceOfIssuance": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "returneeExpirationDate": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortPossible": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "escortFullName": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortNationalityCountryCode": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortPassportNo": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortIssuanceDate": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortExpirationDate": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortIssuingAuthority": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "escortPlaceOfIssuance": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    }
  },
  "transit": {
    "personalDetails": {
      "givenName": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "photograph": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "surname": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "maidenName": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "nationalityCountryCode": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "languageSpoken": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "sex": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "travelDocumentType": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "documentNo": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirth": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "dateOfBirth": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "submittingAgencyReference": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "alias": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "physicalDescription": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "placeOfBirthRegionCity": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    },
    "transitOperation": {
      "admissionGuaranteed": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "typeOfTransit": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "otherStatesOfTransit": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "anyReasonOfRefusal": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "finalDestinationCountryCode": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "proposedCrossingPoint": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "dateAndTimeOfTransfer": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "proposedTransferDate": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "proposedTransferTime": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "escortPossible": {
        "formControl": 0,
        "mandatory": true,
        "enabled": true
      },
      "escortDetails": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      },
      "observations": {
        "formControl": 0,
        "mandatory": false,
        "enabled": true
      }
    }
  }
}
